export const prepareTenantFromUrl = (url) => {
  const websiteName = process.env.REACT_APP_WEBSITE_NAME || '';
  const domainParts = websiteName.split('.');
  const domainName = domainParts[0] || ''; // e.g., "easyboosted" from "more-loads.com"

  let result = url
    .replace("http://", "")
    .replace("https://", "")
    .replace("www.", "")
    .replace("localhost:3000", "")
    .replace(`.${websiteName}`, "")
    .replace("dev", "")
    .replace(".", "")
    .replace(domainName, "")
    .replace(domainParts[1] || '', "") // TLD like "com"
    .replace("www", "");

  return result;
}